export default {"src":"/_next/static/media/aff-4.93384c04.svg","height":63,"width":121};